import { useEffect, useState } from "react";
import api from "@/lib/api";
import { formatHeight, formatWeight } from "./units";
import { useAuth } from "./auth";

// Single source of truth for display unit preference.
// Reads `preferred_units` from the user's profile; falls back to metric.
export function useUnits() {
  const { user } = useAuth();
  const [units, setUnits] = useState("metric");

  useEffect(() => {
    if (!user) return;
    api
      .get("/profile")
      .then((r) => {
        // /api/profile returns {profile: {...}, macros: {...}}; older callers
        // may also receive a flat shape, so check both.
        const p =
          r.data?.profile?.preferred_units ||
          r.data?.preferred_units ||
          "metric";
        setUnits(p === "imperial" ? "imperial" : "metric");
      })
      .catch(() => setUnits("metric"));
  }, [user?.id]);

  return {
    units,
    isImperial: units === "imperial",
    setUnits: async (next) => {
      setUnits(next);
      try {
        await api.post("/profile/units", { preferred_units: next });
      } catch {
        // optimistic — caller can retry
      }
    },
    fmtWeight: (kg) => formatWeight(kg, units),
    fmtHeight: (cm) => formatHeight(cm, units),
  };
}
